import React from 'react';
import {createPortal} from 'react-dom';
import {useDispatch, useSelector} from 'react-redux';
import {FlashMessage} from '@tenancy.nz/design-system';
import {closeToast} from './toastSlice';

function ToastFeature() {
  const dispatch = useDispatch();
  const {show, message, color, horizontal, vertical} = useSelector(
    state => state.toast
  );

  const autoCloseToast = () => dispatch(closeToast());

  return createPortal(
    <FlashMessage
      open={show}
      color={color}
      horizontal={horizontal}
      vertical={vertical}
      onClose={autoCloseToast}
      autoHideDuration={3500}
      variant="standard">
      {message}
    </FlashMessage>,
    document.body
  );
}

export default ToastFeature;
